import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/bVMu1ysL7RbVQBP5vfeWYJ/Pack_de_Maestria_Reiki_y_chakras.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/mw6kDR1fciKdF9Qhz1AMu6/heylloyd-image-1774029715790.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="min-h-screen pt-20 pb-12 md:pt-28 md:pb-16 px-5 sm:px-6 overflow-hidden relative flex flex-col justify-center" data-id="element-166">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`
    }} data-id="element-167"></div>
      <div className="absolute inset-0 bg-black/88" data-id="element-168"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-169">
        {/* Top Badge */}
        <div className="mb-8" data-id="element-170">
          <span className="text-[#f0c040] text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-171">
            ⭐ ACADEMIA HOLÍSTICA ARGENTINA ⭐
          </span>
        </div>

        {/* Title */}
        <h1 className="mb-6 font-bold tracking-tight leading-none text-white" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-172">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-2" data-id="element-173">
            Maestría de
          </span>
          <span className="block text-[#eab308] text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black italic" data-id="element-174">
            Reiki.
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-gray-300 mb-6 max-w-3xl mx-auto leading-relaxed px-2 text-lg md:text-xl font-medium" data-id="element-175">
          Tu energía necesita un cambio.
          <br data-id="element-176" />
          <br data-id="element-177" />
          Reiki puede ser tu camino para sanar y también una nueva forma de
          generar ingresos.
          <br data-id="element-178" />
          <br data-id="element-179" />✨ Empezá hoy.
        </p>

        {/* Product Image */}
        <div className="block mx-auto max-w-xs sm:max-w-md md:max-w-lg mb-8" data-id="element-180">
          <div className="relative animate-float" data-id="element-181">
            {/* Pulsing glow behind image */}
            <div className="absolute -inset-4 bg-[#eab308]/10 rounded-3xl blur-2xl animate-pulse-glow" data-id="element-182"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#eab308]/30 via-white/5 to-[#eab308]/20 shadow-[0_12px_60px_rgba(234,179,8,0.3)] border border-[#eab308]/20" data-id="element-183">
              <div className="rounded-xl overflow-hidden bg-black" data-id="element-184">
                <img src={PRODUCT_IMG} alt="Sistema Maestría Reiki" className="w-full object-cover block mix-blend-screen" data-id="element-185" />
              </div>
            </div>
          </div>
        </div>

        {/* Quote */}
        <p className="text-[#eab308] font-serif font-bold italic text-xl md:text-2xl tracking-wide mb-6" data-id="element-186">
          "Listo para aprender. Sin experiencia previa."
        </p>

        {/* Social Proof */}
        <p className="text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed px-2 text-base md:text-lg" data-id="element-187">
          El sistema que ya eligieron{' '}
          <span className="text-white font-bold" data-id="element-188">+1.000 alumnos</span> en
          Argentina para formarse en Reiki desde cero.
        </p>

        {/* Pill Badges */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-6" data-id="element-189">
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-4 py-1.5 backdrop-blur-sm animate-in delay-100" data-id="element-190">
            📱 100% Digital
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-4 py-1.5 backdrop-blur-sm animate-in delay-300" data-id="element-191">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-4 py-1.5 backdrop-blur-sm animate-in delay-500" data-id="element-192">
            🎓 De cero a Maestro/a
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-3 w-full max-w-xl mx-auto" data-id="element-193">
          <a href="#pricing-offer" className="w-full block px-4 sm:px-6 py-4 md:py-5 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base md:text-lg tracking-wider sm:tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-194">
            🔥 QUIERO EL SISTEMA MAESTRÍA REIKI
          </a>

          <p className="text-gray-400 text-xs md:text-sm font-medium mt-2" data-id="element-195">
            💳 Mercado Pago — Tarjeta de crédito — Transferencia
          </p>
          <p className="text-gray-500 text-xs md:text-sm font-medium mt-1" data-id="element-196">
            🔒 Pago seguro — Acceso inmediato — Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}